<template>
	<div class="ah-modal-overlay" @click="modalVisibilityUpdated">
		<div class="ah-modal-container">
			<div class="ah-modal-inner-container">
				<div class="ah-modal-content">
					<div @click="modalVisibilityUpdated" class="ah-modal-close">&times;</div>
					<slot></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
const props = defineProps(['modalVisible']);
const emit = defineEmits(['modalVisibilityUpdated']);
const modalVisibilityUpdated = (event) => {
	if (event.target.classList.contains('ah-modal-overlay') || event.target.classList.contains('ah-modal-close')) {
		emit('modalVisibilityUpdated', false);
	}
}
</script>
